import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileInfo, FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';

@Component({
    selector: 'import-bid',
    templateUrl: './import-bid.component.html',
    styleUrls: ['./import-bid.component.scss'],
    standalone: false
})
export class ImportBidComponent {

    @Output() selected: EventEmitter<Array<FileInfo>> = new EventEmitter<Array<FileInfo>>();
    @Input() clearAfterSelect: boolean = true;
    @Input() disabled: boolean = false;
    files: Array<FileInfo> = [];
    uploadError: string;
    constructor() {

    }
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.xlsx', '.xls']
    };

    private validateFiles(event: SelectEvent): boolean {
        const invalidFile = event.files.find(file =>
            !this.uploadRestrictions.allowedExtensions.includes(file.extension)
        );

        if (invalidFile) {
            this.uploadError = `File type ${invalidFile.extension} is not allowed. Allowed types: ${this.uploadRestrictions.allowedExtensions.join(', ')}`;
            event.preventDefault();
            return false;
        }

        return true;
    }

    selectEventHandler(e: SelectEvent) {
        if (!this.validateFiles(e)) {
            return;
        }
        this.files = e.files;
        this.selected.emit(this.files);
        if (this.clearAfterSelect) {
            this.clear();
        }
    }
    clear() {
        this.files = [];
    }
    completeEventHandler(e: any) {
        //noop
    }
}

